module.exports = __webpack_public_path__ + "static/img/ecom-tl.9be98331.svg";